module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "lte-small-box small-box",
    class: _vm.boxBgClass,
    style: (_vm.boxStyle)
  }, [_c('div', {
    staticClass: "inner"
  }, [_vm._t("default")], 2), _vm._v(" "), _c('div', {
    staticClass: "icon"
  }, [_c('i', {
    class: _vm.icon
  })]), _vm._v(" "), (!!_vm.$slots['box-footer']) ? _c('a', {
    staticClass: "small-box-footer",
    attrs: {
      "href": "javascript:;"
    },
    on: {
      "click": _vm.footerClick
    }
  }, [_vm._t("box-footer")], 2) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-49ae9853","hasScoped":false}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/small-box/small-box.vue
// module id = 13
// module chunks = 0